import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Subscription } from "rxjs/Subscription";
import { NotificationsService } from "angular2-notifications";
import { ConfirmationService } from "@jaspero/ng2-confirmations";
import { ResolveEmit } from "@jaspero/ng2-confirmations/src/interfaces/resolve-emit";
import { ModalDirective } from "ngx-bootstrap";

import { GUID } from "app/brightserve/brightserve.module";
import { Allergy, SlimScrollOptions } from "app/shared/shared.module";

import { AddonService } from "app/add-ons/addon.service";

@Component({
    selector: 'app-addon-allergy',
    templateUrl: './addon-allergy.component.html',
    styleUrls: ['./addon-allergy.component.css']
})
export class AddonAllergyComponent implements OnInit {

    AllergyFilter: string;
    AllergyTypeList: string[] = ["Anaphylactic", "Sensitivity", "Intolerance", "Other"];
    Allergies: Allergy[];

    NewAllergy: Allergy = Allergy.BlankAllergy();

    SlimScrollOptions = SlimScrollOptions;

    GetAllergiesSubscription: Subscription;
    SaveAllergySubscription: Subscription;
    RemoveAllergySubscription: Subscription;

    @Input() PatientId: GUID;
    @Input() EnableAdd: boolean = false;
    @Input() EnableDelete: boolean = false;
    @Input() EnableEdit: boolean = false;

    CanEnableAdd: boolean = false;
    CanEnableDelete: boolean = false;
    CanEnableEdit: boolean = false;

    @ViewChild('AllergyModal') public modal: ModalDirective

    constructor(private addonService: AddonService, private _confirmation: ConfirmationService, private _notification: NotificationsService) { }

    ngOnInit() {
        this.CanEnableAdd = this.EnableAdd;
        this.CanEnableDelete = this.EnableDelete;
        this.CanEnableEdit = this.EnableEdit;
    }

    ngOnChanges() {
        if (this.PatientId) {
            this.GetAllergies();
            this.EnableAdd = this.CanEnableAdd;
            this.EnableDelete = this.CanEnableDelete;
            this.EnableEdit = this.CanEnableEdit;
        }
        else {
            this.EnableAdd = false;
            this.EnableDelete = false;
            this.EnableEdit = false;
        }
    }

    ngOnDestroy() {
        if (this.GetAllergiesSubscription != null)
            this.GetAllergiesSubscription.unsubscribe();
        if (this.SaveAllergySubscription != null)
            this.SaveAllergySubscription.unsubscribe();
        if (this.RemoveAllergySubscription != null)
            this.RemoveAllergySubscription.unsubscribe();
    }

    GetAllergies() {
        this.AllergyFilter = "";
        if (this.PatientId) {
            this.GetAllergiesSubscription = this.addonService.GetAllergiesForPatient(this.PatientId).subscribe(
                allergies => {
                    this.Allergies = allergies;
                }, err => {
                    this._notification.error("Data Error", "Allergy data for this patient could not be obtained.");
                }
            );
        }
    };

    OpenModal(allergy: Allergy) {
        if (!allergy)
            this.NewAllergy = Allergy.BlankAllergy();
        else
            this.NewAllergy = new Allergy(allergy);
        this.modal.show();
    }

    SaveNewAllergy() {
        this.NewAllergy.Type.Entity = 'Allergy';
        this.NewAllergy.Type.Field = 'Type';
        this.SaveAllergySubscription = this.addonService.AddAllergyToPatient(this.PatientId, this.NewAllergy).subscribe(
            data => {
                this._notification.success("Save Success", "Your allergy was saved successfully.");
                this.modal.hide();
                this.GetAllergies();
            }, err => {
                this._notification.error("Save Error", "Your allergy was not saved successfully.");
            }
        );
    };

    RemoveAllergyToPatient(event, allergy: Allergy) {
        event.stopPropagation();
        this._confirmation.create('Remove Allergy?', 'Are you sure you want to remove this allergy?')
            .subscribe((ans: ResolveEmit) => ans.resolved ? this.RemoveAllergy(allergy): null);
    };

    private RemoveAllergy(allergy: Allergy) {
        this.RemoveAllergySubscription = this.addonService.RemoveAllergyToPatient(allergy.Id).subscribe(
            data => {
                this._notification.success("Remove Success", "Your allergy was removed successfully.");
                this.GetAllergies();
            }, err => {
                this._notification.error("Remove Error", "Your allergy was not removed successfully.");
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/app/add-ons/allergy/addon-allergy.component.ts